import VrrGallery from './VrrGallery';

export default VrrGallery;
